import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import ChangePasswordProvider from '../../components/ChangePasswordProvider';
import ChangePasswordForm from './ChangePasswordForm';

export interface ChangePasswordPageProps {
  title: string;
  mobileDeviceMode: Boolean;
}

const ChangePasswordPage: FC<ChangePasswordPageProps> = ({ title, mobileDeviceMode }) => (
  <>
    <Helmet><title>{title}</title></Helmet>
    <ChangePasswordProvider>
      <ChangePasswordForm mobileDeviceMode={mobileDeviceMode} />
    </ChangePasswordProvider>
  </>
);
export default ChangePasswordPage;
